// Which AIM tabs a user may see. The System tab (queue health, run errors, run
// history) is an operations view, so only admin roles see it: platform_admin,
// org_owner and org_admin — the same set `useView().isAdmin` reports.

/** Tab keys that only admin roles may open. */
export const ADMIN_ONLY_TABS = new Set(['system']);

/**
 * The tabs to show in the tab bar for this user.
 * @param {Array<{key: string}>} tabs  the full tab list, in display order
 * @param {boolean} isAdmin            `useView().isAdmin`
 */
export const visibleTabs = (tabs, isAdmin) =>
  (isAdmin ? tabs : tabs.filter((t) => !ADMIN_ONLY_TABS.has(t.key)));

/**
 * The tab to actually render. A non-admin who reaches an admin-only tab through
 * the URL (`?tab=system`) lands on Overview instead of the hidden tab's content.
 * @param {string} requested  the tab key from the URL
 * @param {boolean} isAdmin   `useView().isAdmin`
 */
export const resolveTab = (requested, isAdmin) =>
  (!isAdmin && ADMIN_ONLY_TABS.has(requested) ? 'overview' : requested);
